import type { RouteObject } from 'react-router-dom';

import MainLayout from '@/app/layouts/MainLayout';
import { AuthGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * 견적함(/quotes) 라우트.
 * AuthGuard(로그인) → 목록/상세. 상세는 인쇄용 견적서 양식.
 */
export const quotesRoutes: RouteObject = {
  path: ROUTES.QUOTES,
  Component: MainLayout,
  children: [
    {
      element: <AuthGuard />,
      children: [
        {
          index: true,
          ...lazyRoute(() => import('@/pages/quotes/QuoteListPage')),
        },
        {
          path: ':id',
          ...lazyRoute(() => import('@/pages/quotes/QuoteDetailPage')),
        },
      ],
    },
  ],
};
